module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-bookmark-fill-da9b72ca.svg";